import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Pagination, Switch } from "@mui/material";
import { t } from "i18next";
import moment from "moment";
import { GetSessionStorageData, checkEmpty } from "../../../../Services/Helpers/Helper";
import NoDataFound from "../../../../Shared/NoDataFound/NoDataFound";
import { STORAGE_KEYS, NUMBER_CONSTANTS, COMMON_CONSTANTS, API_RESPONSE, DIALOG_CONSTANT, TOASTER_CONFIGS } from "../../../../Utilities/Constants/Constants";
import "./DiscountsList.scss";
import { useEffect, useState } from "react";
import edit from "../../../../../Assets/global/edit.svg";
// import CreateDiscounts from "../CreateDiscounts/CreateDiscounts";
import { axiosInstance } from "../../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../../Utilities/Constants/ApiEndpoints";
import CreateDiscounts from "../CreateDiscounts/CreateDiscounts";
import ConfirmationDialog from "../../../../Shared/ConfirmationDialog/ConfirmationDialog";
import { toast } from "react-toastify";

const DiscountsList = () => {
    const [page, setPage] = useState(1);
    const [totalPage, setTotalCount] = useState(0);
    const [rowPerPage, setRowPerPage] = useState(10);
    const [hasProducts, setHasProducts] = useState(API_RESPONSE.FALSE);
    const [discountCreateMode, setDiscountCreateMode] = useState("create");
    const [discountData, setDiscountData] = useState<any>({});
    const [campDialogStatus, setCampDialogStatus] = useState(false);
    const [discountsList, setDiscountsList] = useState([]);
    const [currentData, setCurrentData] = useState<any>({});
    const [modalStatus, setmodalStatus] = useState(false);
    const [dialogContent, setDialogContent] = useState(
        DIALOG_CONSTANT.ACTIVATE_DISCOUNT
      );
      
    useEffect(()=>{
        getDiscountsList();
    },[page,rowPerPage])

    /**Handle row per page change */
  const onRowChange = (event: any) => {
    setPage(COMMON_CONSTANTS.ONE)
    setRowPerPage(parseInt(event.target.value));
  };

  const handleChangePage = (event: React.ChangeEvent<any>, newPage: number) => {
    setPage(newPage);
  };

    /* Handling dialog close */
    const onCloseCampDialog = () => {
        setDiscountData({});
        setCampDialogStatus(false);
        getDiscountsList();
      };

      
    const tutorLengthCheck = (data: any) => {
        data.length > 0 ? setHasProducts(true) : setHasProducts(false);
    };

      const getDiscountsList = () => {
          axiosInstance
          .get(
            API_END_POINTS.CAMP_DISCOUNT_LIST + "?page=" + page + "&limit=" + rowPerPage /* + "&discount_type=" + userType */ 
          )
          .then((response: any) => {
            if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
              setDiscountsList(response.data.result.data);
              setHasProducts(checkEmpty(response.data.result.data));
              tutorLengthCheck(response.data.result.data);
              setTotalCount(response.data.result.total_page);
            }
          });
          
      };

      
    const onCheckSwitch = (event: any, data: any) => {
        setCurrentData(data);
        if (data.is_active) {
          setDialogContent(DIALOG_CONSTANT.DEACTIVATE_DISCOUNT);
          
        }else{
            setDialogContent(DIALOG_CONSTANT.ACTIVATE_DISCOUNT);
        };
        setmodalStatus(API_RESPONSE.TRUE);
      };
      

      const onActivateDeactivate = (status: any) => {
        if (status === API_RESPONSE.TRUE) {
          axiosInstance
            .delete(API_END_POINTS.MANAGE_CAMPS_DISCOUNT + "?id=" + currentData.id)
            .then((response: any) => {
              if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
                toast.success(response.data.message, TOASTER_CONFIGS);
                getDiscountsList();
              }
            });
        }
        setmodalStatus(API_RESPONSE.FALSE);
      };

    return (
        <div className="discount-listview-wrapper">

     <CreateDiscounts
        modalState={campDialogStatus}
        mode={discountCreateMode}
        data={discountData}
        dialogStatus={onCloseCampDialog}
        />

      <ConfirmationDialog
          content={dialogContent}
          modalState={modalStatus}
          dialogStatus={onActivateDeactivate}
        />

      <div className="table-wrapper">

            <div className="discount-button-wrap">
            <button
                        type="submit"
                        className="btn btn-secondary"
                        onClick={() => {
                        setDiscountCreateMode("create");
                        setCampDialogStatus(true)
                        // userType===3 ? setCampDialogStatus(true) : setDialogOpenStatus(true);
                        }}
                    >
                        Create Discount
                    </button>
            </div>
        <div className="basic-detail-wrapper">
          <div className="row">
            <div className="col-md-6">

            </div>
          </div>
        </div>

        
          <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t("S.NO")}</TableCell>
                <TableCell>{t("Discount Name")}</TableCell>
                <TableCell>{t("Child Count")}</TableCell>
                <TableCell>{t("Discount in %")}</TableCell>
                <TableCell>{t("Actions")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {discountsList?.map((expertData: any, index: any) => {
                return (
                  <>
                    <TableRow key={index + 1}>
                      <TableCell> {page - 1 === 0
                            ? index + 1
                            : (page - 1) * rowPerPage + (index + 1)}</TableCell>
                      <TableCell>{expertData.name}</TableCell>
                      <TableCell>{expertData.buy_sessions}</TableCell>
                      <TableCell>{expertData.discount}</TableCell>
                      <TableCell>
                        <img
                          onClick={() => {
                            setDiscountData(expertData);
                            setDiscountCreateMode('edit');
                            setCampDialogStatus(true);
                          }}
                          className="view_edit_icons"
                          src={edit}
                          alt="Learn and Play"
                        />
                        <Switch
                          onChange={(e: any) => onCheckSwitch(e, expertData)}
                          checked={expertData.is_active}
                        />
                      </TableCell>
                    </TableRow>
                  </>
                );
              })}
            </TableBody>
          </Table>
          {!hasProducts && <NoDataFound />}
        </TableContainer>
        
        {hasProducts && (
          <div className="tablePagination">
            <div className="row">
              <div className="col-md-7">
                <div className="pagination-wrap">
                  <Pagination
                    count={totalPage}
                    page={page}
                    onChange={handleChangePage}
                  />
                </div>
              </div>
              <div className="col-md-5">
                <div className="rows-per-page">
                  <p>{t("Rows per page")}:</p>
                  <select
                    className="rows-select"
                    value={rowPerPage}
                    onChange={onRowChange}
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
    )

};
export default DiscountsList;